import { SystemEntity } from '@erp/shared-types';
import {
  FileTextIcon,
  ListChecksIcon,
  ShoppingCartIcon,
  PackageIcon,
  EnvelopeIcon,
  FlowArrowIcon,
  PlayCircleIcon,
  CircleIcon,
  BookOpenIcon,
  FilesIcon,
  Icon,
  QuestionIcon,
  BuildingsIcon,
  FileIcon,
  ScanIcon,
  CreditCardIcon,
  ArrowsLeftRightIcon,
  CurrencyDollarIcon,
  UserIcon,
  TruckIcon,
} from '@phosphor-icons/react';

/**
 * Icon mapping for system entities
 * Maps each SystemEntity to a Lucide icon component
 */
export const systemEntityIcons: Record<SystemEntity, Icon> = {
  // CORE
  [SystemEntity.CORE_MEMORY_BANK_NOTE]: BookOpenIcon,
  [SystemEntity.CORE_MEMORY_BANK_NOTE_USAGE]: FilesIcon,
  [SystemEntity.ORGANIZATION]: BuildingsIcon,
  [SystemEntity.CORE_DOCUMENT]: FileIcon,
  [SystemEntity.CORE_DOCUMENT_OCR_RESULT]: ScanIcon,

  // AR
  [SystemEntity.AR_CUSTOMER]: UserIcon,
  [SystemEntity.AR_STAGED_SALES_ORDER]: ShoppingCartIcon,
  [SystemEntity.AR_SALES_ORDER]: ShoppingCartIcon,
  [SystemEntity.AR_SALES_ORDER_LINE_ITEM]: ListChecksIcon,

  // AP
  [SystemEntity.AP_INVOICE]: FileTextIcon,
  [SystemEntity.AP_INVOICE_LINE_ITEM]: ListChecksIcon,
  [SystemEntity.AP_SUPPLIER]: BuildingsIcon,
  [SystemEntity.INTERNAL_PURCHASE_ORDER]: PackageIcon,
  [SystemEntity.INTERNAL_PURCHASE_ORDER_LINE_ITEM]: ListChecksIcon,

  // FINANCE
  [SystemEntity.PAYMENT]: CreditCardIcon,
  [SystemEntity.FINANCIAL_TRANSACTION]: ArrowsLeftRightIcon,
  [SystemEntity.CHARGE]: CurrencyDollarIcon,

  // SUPPLY CHAIN MANAGEMENT
  [SystemEntity.SCM_SHIPMENT]: TruckIcon,
  [SystemEntity.SHIPPING_DOCUMENT]: FileTextIcon,
  [SystemEntity.SHIPPING_DOCUMENT_LINE_ITEM]: ListChecksIcon,

  // EMAILS
  [SystemEntity.INBOUND_EMAIL]: EnvelopeIcon,
  [SystemEntity.OUTBOUND_EMAIL]: EnvelopeIcon,

  // WORKFLOWS
  [SystemEntity.WORKFLOW_DEFINITION]: FlowArrowIcon,
  [SystemEntity.WORKFLOW_RUN]: PlayCircleIcon,
  [SystemEntity.STEP_RUN]: CircleIcon,
};

/**
 * Get the icon for a system entity
 */
export function getEntityIcon(entityType: SystemEntity): Icon {
  return systemEntityIcons[entityType] ?? QuestionIcon;
}
